var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40.7 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 52v-14.2h2.5v-19.1h-2.5v-13.61l5.1-5.09h20.8v14.2h-2.6v19.1h3.3v-2.5h14.1v16.03l-5.16 5.17z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.6 31.9h-11.9v2.5h-5.5v-21.3h2.6v-12h-19.23l-4.47 4.46v12.04h2.5v21.3h-2.5v12h33.97l4.53-4.54z",
    className: "cjd-stroke",
    fill: "#8089a2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.06 11.94v23.59h7.75v-2.53h9.65v12.24h-31.8v-9.71h2.58v-23.59h-2.58v-9.71h17v9.71z",
    className: "cjd-fill",
    fill: "#f9fbfe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL);
export default __webpack_public_path__ + "static/media/l.043401e9a66b8e3ca170e6e333a0e64f.svg";
export { ForwardRef as ReactComponent };